import { OrdersConfig, Visibility } from '@components/framework/orders/validation.ts';

export const generateTimeslotOrderConfig = (requiredOrderItems: boolean, cargoDimensions: Visibility = 'never'): OrdersConfig => {
  return {
    orderName: {
      visibility: 'always',
      required: true,
    },
    cargo: {
      visibility: requiredOrderItems ? 'always' : 'optional',
      required: requiredOrderItems,
    },
    cargoDimensions: {
      visibility: cargoDimensions,
      required: true,
      items: {
        width: {
          required: true,
        },
        height: {
          required: true,
        },
        length: {
          required: true,
        },
        weight: {
          required: true,
        },
      },
    },
    cargoDetails: {
      visibility: 'never',
      required: true,
      items: {
        orderAmount: {
          required: true,
        },
        orderDescription: {
          required: true,
        },
        orderValue: {
          required: true,
        },
      },
    },
    orderTotalWeight: {
      render: false,
    },
    unloadingLocationId: {
      render: false,
    },
  };
};
